export default __webpack_public_path__ + "static/media/CapitalOne.1e0f153d.svg";